import type { ParsedUrlQuery } from "querystring"

import { AVAILABLE_LOCALES } from "@/modules/i18n/constants"

export function parsedUrlQueryToURLSearchParams(
  query: ParsedUrlQuery,
  searchParams = new URLSearchParams()
): URLSearchParams {
  Object.entries(query).forEach(([key, values]) => {
    if (!values || values.length === 0) {
      searchParams.delete(key)
    } else if (!Array.isArray(values)) {
      searchParams.set(key, values)
    } else {
      searchParams.delete(key)
      values.forEach(value => {
        searchParams.append(key, value)
      })
    }
  })

  return searchParams
}

export function urlSearchParamsToParsedUrlQuery(
  searchParams: URLSearchParams,
  query: ParsedUrlQuery = {}
): ParsedUrlQuery {
  const newQuery = { ...query }

  searchParams.forEach((value, name) => {
    if (!query[name]) {
      newQuery[name] = value
    } else {
      if (!Array.isArray(newQuery[name])) {
        newQuery[name] = [`${newQuery[name]}`]
      }

      ;(newQuery[name] as string[]).push(value)
    }
  })

  return newQuery
}

export function isHome(pathname: string): boolean {
  return AVAILABLE_LOCALES.map(locale => new RegExp(`/${locale}/?$`)).some(regexp => regexp.test(pathname))
}
